// START IMPORTS
import { useSubscriptionAccessConfigContext } from '@ltvco/refresh-lib/ctx';
import { Box } from '@ltvco/refresh-lib/theme';
import { Header } from '@ltvco/refresh-lib/v2';
import { useFeatureIsOn } from '@ltvco/refresh-lib/vendors';
import { useEffect } from 'react';
// END IMPORTS

// START INTERFACES_AND_TYPES
type HeaderParentProps = {
  handleSearchSuccess: any;
  // eslint-disable-next-line no-unused-vars
  changeSingleReportVariation: (variation: boolean) => void;
  // eslint-disable-next-line no-unused-vars
  changeOwnerSearchVariation: (variation: boolean) => void;
  // eslint-disable-next-line no-unused-vars
  changeIsInAstrologyStandaloneVariation: (variation: boolean) => void;
  // eslint-disable-next-line no-unused-vars
  changeInternationalLanguageTest: (variation: boolean) => void;
  // eslint-disable-next-line no-unused-vars
  changeInternationalVinTest: (variation: boolean) => void;
  // eslint-disable-next-line no-unused-vars
  changeListV2Variation: (variation: boolean) => void;
  // eslint-disable-next-line no-unused-vars
  changeCourtCasesVariation: (variation: boolean) => void;
  // eslint-disable-next-line no-unused-vars
  changeIsInConsolidatedMenuItemsVariation: (variation: boolean) => void;
};
// END INTERFACES_AND_TYPES

export const HeaderParent = ({
  handleSearchSuccess,
  changeSingleReportVariation,
  changeOwnerSearchVariation,
  changeIsInAstrologyStandaloneVariation,
  changeInternationalLanguageTest,
  changeInternationalVinTest,
  changeListV2Variation,
  changeIsInConsolidatedMenuItemsVariation,
  changeCourtCasesVariation,
}: HeaderParentProps) => {
  // START HOOKS_AND_QUERIES
  const isInOwnerSearchVariation = useFeatureIsOn('prop-2561');
  const isInAstrologyStandaloneVariation = useFeatureIsOn('oar-1164');
  const isInListV2Variation = useFeatureIsOn('prop-2834');
  const isInCourtCasesVariation = useFeatureIsOn('court-case-search');
  const isInConsolidatedMenuItemsVariation = useFeatureIsOn('RFRSH-3117');
  const {
    singleReportVariation,
    internationalLanguageVariation,
    vinVariation,
  } = useSubscriptionAccessConfigContext();
  // END HOOKS_AND_QUERIES

  // START EFFECTS
  useEffect(() => {
    changeSingleReportVariation(singleReportVariation);
  }, [singleReportVariation]);

  useEffect(() => {
    changeOwnerSearchVariation(isInOwnerSearchVariation);
  }, [isInOwnerSearchVariation]);

  useEffect(() => {
    changeIsInAstrologyStandaloneVariation(isInAstrologyStandaloneVariation);
  }, [isInAstrologyStandaloneVariation]);

  useEffect(() => {
    changeInternationalLanguageTest(internationalLanguageVariation);
  }, [internationalLanguageVariation]);

  useEffect(() => {
    changeInternationalVinTest(vinVariation);
  }, [vinVariation]);

  useEffect(() => {
    changeListV2Variation(isInListV2Variation);
  }, [isInListV2Variation]);

  useEffect(() => {
    changeCourtCasesVariation(isInCourtCasesVariation);
  }, [isInCourtCasesVariation]);

  useEffect(() => {
    changeIsInConsolidatedMenuItemsVariation(
      isInConsolidatedMenuItemsVariation
    );
  }, [isInConsolidatedMenuItemsVariation]);
  // END EFFECTS

  // START EARLY_RETURNS
  if (location.pathname.includes('/chatbv')) {
    return null;
  }
  // END EARLY_RETURNS

  // START RENDER
  return (
    <Box>
      <Header onSearchSuccess={handleSearchSuccess} />
    </Box>
  );
  // END RENDER
};
